import React from 'react'
import type { PresentationBlock } from 'paintscout'

import { ButtonOption } from '../../components'
import makeRowHandlers from '../../util/makeRowHandlers'

import AddIcon from '@material-ui/icons/Add'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'

interface DocumentsOptionsProps {
  block: PresentationBlock
  handleOptionFieldChange: (field: string, value: any) => void
}

function DocumentsOptions(props: DocumentsOptionsProps) {
  const { block, handleOptionFieldChange } = props
  const { rows } = block.fields

  const { handleAddRow, handleRemoveLastRow } = makeRowHandlers({
    rows,
    newRow: { title: '', content: '', image: null },
    handleOptionFieldChange
  })

  const options = [
    {
      Component: (
        <ButtonOption
          label={'Documents'}
          buttons={[
            { icon: <AddIcon />, onClick: handleAddRow },
            ...(rows?.length ? [{ icon: <DeleteOutlineIcon />, onClick: handleRemoveLastRow }] : [])
          ]}
        />
      ),
      tab: 'content'
    }
  ]

  return options
}

export default DocumentsOptions
